import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type Locale = "en" | "nl";

type LanguagePreferenceState = {
  language: Locale;
  pendingLocaleSync: boolean;
  setLanguage: (language: Locale) => void;
  setLanguageFromBackend: (language: Locale) => void;
};

export const syncLocaleToBackend = async (locale: Locale) => {
  try {
    const { useClientStore } = await import("@/shared/gql/apollo-client");
    const { graphql } = await import("@/shared/gql");

    const client = useClientStore.getState().client;
    if (!client) return;

    const UpdateLocale = graphql(`
      mutation UpdateLocale($input: UpdateProfileInput!) {
        updateProfile(input: $input) {
          id
          locale
        }
      }
    `);

    await client.mutate({
      mutation: UpdateLocale,
      variables: { input: { locale } },
    });
  } catch (e) {
    console.error("Failed to sync locale to backend", e);
  }
};

const useLanguagePreferenceStore = create<LanguagePreferenceState>()(
  persist(
    (set) => ({
      language: "nl" as Locale,
      pendingLocaleSync: false,
      setLanguage: (language: Locale) => {
        set({ language, pendingLocaleSync: true });
        syncLocaleToBackend(language);
      },
      setLanguageFromBackend: (language: Locale) => {
        set({ language, pendingLocaleSync: false });
      },
    }),
    {
      name: "language-preference-storage",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export const useLanguagePreference = useLanguagePreferenceStore;
